import React from 'react';

export const CheckboxDisableIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6331_7264)">
            <rect width="24" height="24" rx="4" fill="#BABABA" fillOpacity="0.4" />
            <rect x="1" y="1" width="22" height="22" rx="3" stroke="#BABABA" strokeWidth="2" />
        </g>
        <defs>
            <clipPath id="clip0_6331_7264">
                <rect width="24" height="24" rx="4" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
